// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSection_heroSection__JPhb6","countersContainer":"HeroSection_countersContainer__IeiW0","counterColumn":"HeroSection_counterColumn__NVOSm"};